import { Button, ButtonLabel } from "@similarweb/ui-components";
import I18n from "pro-features/components/WithTranslation/src/I18n";

import type { FC } from "react";

export const AddToDashboardModalButton: FC<any> = ({ type = "", ...props }) => {
    let key;
    //class name for tracking in GTM
    let classNameGTM = null;
    if (props.isSaving && props.isSuccess) {
        key = props.multipleDashboards
            ? "common.addtodashboard.wizard.cta.done.multiple"
            : "common.addtodashboard.wizard.cta.done";
    } else {
        key = "common.addtodashboard.wizard.cta";
        classNameGTM = "gtm_user_event_click_add_to_dashboard";
    }
    return (
        <Button
            style={{ marginTop: "27px", minWidth: "104px" }}
            type={type}
            isDisabled={props.isDisabled}
            onClick={props.onClick}
        >
            <ButtonLabel className={classNameGTM}>
                <I18n>{key}</I18n>
            </ButtonLabel>
        </Button>
    );
};
